import React from 'react'
import EventsPageBody from 'redesign/components/templates/events-page-body'
import SubheaderTabProvider from 'redesign/services/SubheaderTabs/SubheaderTabProvider'
import type { OwnerIdPageProps } from 'redesign/shared/types'
import { EVENT_TABS, PAGES } from './constants'

const EventsPage: React.FC<OwnerIdPageProps> = (props) => (
  <SubheaderTabProvider pages={PAGES} defaultSelectedTabName={EVENT_TABS.upcoming}>
    <EventsPageBody {...props} />
  </SubheaderTabProvider>
)

export default EventsPage
